import { render, staticRenderFns } from "./detailIngameMyswingbg.vue?vue&type=template&id=5bd9e474&scoped=true"
import script from "./detailIngameMyswingbg.vue?vue&type=script&lang=js"
export * from "./detailIngameMyswingbg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd9e474",
  null
  
)

export default component.exports